import { api } from './axios'
import type {
  CreatePlanDto,
  PatchPlanDto,
  PlanResponseDto,
  PlanResponseWithStatsDto,
  PlanTenantResponseDto,
  PlanWithBillingDto,
  QpaServicesResponseDto,
} from './types'

// Get all plans (paginated, with filters)
export const getPlans = async (
  params?: Record<string, any>,
): Promise<{
  data: (PlanResponseDto | PlanWithBillingDto)[]
  hasPendingCancellation: boolean
  pageInfo: any
  totalCount: number
}> => {
  const response = await api.get('/plans', { params })

  return response.data
}

// Get plan by ID
export const getPlanById = async (id: string): Promise<PlanResponseWithStatsDto> => {
  const response = await api.get(`/plans/${id}`)

  return response.data
}

// Create a new plan
export const createPlan = async (data: CreatePlanDto): Promise<PlanResponseDto> => {
  const response = await api.post('/plans', data)

  return response.data
}

// Patch (update) a plan
export const patchPlan = async (id: string, data: PatchPlanDto): Promise<PlanResponseDto> => {
  const response = await api.patch(`/plans/${id}`, data)

  return response.data
}

// Delete a plan
export const deletePlan = async (id: string): Promise<void> => {
  const response = await api.delete(`/plans/${id}`)

  return response.data
}

// Activate a plan
export const activatePlan = async (id: string): Promise<PlanResponseDto> => {
  const response = await api.post(`/plans/${id}/activate`)

  return response.data
}
// Deactivate a plan
export const deactivatePlan = async (id: string): Promise<PlanResponseDto> => {
  const response = await api.post(`/plans/${id}/deactivate`)

  return response.data
}

// Get tenants using a plan
export const getPlanTenants = async (
  id: string,
  params?: Record<string, any>,
): Promise<{ data: PlanTenantResponseDto[]; pageInfo: any; totalCount: number }> => {
  const response = await api.get(`/plans/${id}/tenants`, { params })

  return response.data
}

// Get activated QPA services for the current user's plan
export const getMyQpaServices = async (): Promise<QpaServicesResponseDto> => {
  const response = await api.get('/plans/my-qpa-services')

  return response.data
}
